import {VirtualTeamsConstant as constants} from '../../../_constants/VirtualTeams/VirtualTeams.constants';

const initialStateList = { member_list_loading : true, member_list_data: [], member_list_error: false };

export function virtualMemberList(state = initialStateList, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_MEMBER_LIST_LOADING:
            return {
                member_list_loading: true,
                member_list_data: [],
                member_list_error: false
            };
        case constants.VIRTUAL_MEMBER_LIST_DATA:
            return {
                member_list_loading: false,
                member_list_data: action.virtual_team_members,
                member_list_error: false
            };
        case constants.VIRTUAL_MEMBER_LIST_ERROR:
            return {
                member_list_loading: false,
                member_list_data: [],
                member_list_error: true
            };
        default:
            return state
    }
}

const initialStateAdd = { member_add_loading : true, member_add_data: [], member_add_error: false };

export function virtualMemberAdd(state = initialStateAdd, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_MEMBER_ADD_LOADING:
            return {
                member_add_loading: true,
                member_add_data: [],
                member_add_error: false
            };
        case constants.VIRTUAL_MEMBER_ADD_DATA:
            return {
                member_add_loading: false,
                member_add_data: action.virtual_add_add_members,
                member_add_error: false
            };
        case constants.VIRTUAL_MEMBER_ADD_ERROR:
            return {
                member_add_loading: false,
                member_add_data: [],
                member_add_error: true
            };
        default:
            return state
    }
}

const initialStateUpdate = { member_update_loading : true, member_update_data: [], member_update_error: false };

export function virtualMemberUpdate(state = initialStateUpdate, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_MEMBER_UPDATE_LOADING:
            return {
                member_update_loading: true,
                member_update_data: [],
                member_update_error: false
            };
        case constants.VIRTUAL_MEMBER_UPDATE_DATA:
            return {
                member_update_loading: false,
                member_update_data: action.virtual_update_members,
                member_update_error: false
            };
        case constants.VIRTUAL_MEMBER_UPDATE_ERROR:
            return {
                member_update_loading: false,
                member_update_data: [],
                member_update_error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/VirtualTeams/VirtualTeamMemberList/VirtualTeamMemberList.reducer.js